/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CardNumber,
  CardNumberOptional,
  CardNumberMetaI,
  CardNumberTrackedI,
} from "./card-number";
import { CardNumberTracked, CardNumberMeta } from "./card-number";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CardRef,
  CardRefOptional,
  CardRefMetaI,
  CardRefTrackedI,
} from "./card-ref";
import { CardRefTracked, CardRefMeta } from "./card-ref";

/**
 *
 * @export
 * @interface CardNumDTO
 */
export interface CardNumDTOOptional extends CardNumberOptional {
  /**
   *
   * @type {number}
   * @memberof CardNumDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CardNumDTO
   */
  cardNum?: string;
}

export interface CardNumDTO extends CardNumDTOOptional, CardNumber, CardRef {
  /**
   *
   * @type {number}
   * @memberof CardNumDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CardNumDTO
   */
  cardNum: string;
}

export interface CardNumDTOTrackedI extends CardNumberOptional {
  /**
   *
   * @type {number}
   * @memberof CardNumDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CardNumDTO
   */
  cardNum?: string;
  cardNumIsSet: boolean;
}

transformDatesMap.set("CardNumDTO", function (model: CardNumDTO) {});

export type CardNumDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  cardNum: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CardNumDTOMeta: CardNumDTOMetaI = {} as CardNumDTOMetaI;
CardNumDTOMeta = typeMeta("CardNumDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  cardNum: propertyMeta("cardNum", false, true, false, MetaTypesBase.string),
});

const metaI = CardNumDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CardRefMeta]);
  metaI.assignId.inheritedFrom = CardRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([CardNumberMeta]);
  metaI.cardNum.inheritedFrom = CardNumberMeta.cardNum;
});

export class CardNumDTOTracked
  extends CardNumberTracked
  implements CardNumDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  cardNum__I?: string = undefined;
  cardNumIsSet: boolean = false;
  set cardNum(v: undefined | string) {
    if (v !== undefined) {
      this.cardNum__I = v;
      this.cardNumIsSet = true;
    } else {
      this.cardNum__I = v || undefined;
      this.cardNumIsSet = true;
    }
    this.changeTracker = true;
  }
  get cardNum() {
    return this.cardNum__I;
  }
  constructor(config?: CardNumDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: CardNumDTOOptional,
    options?: AssignOptions,
  ): CardNumDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.cardNum && this.cardNumApplyFilter(optionsRequired.filter)) {
      this.cardNum = config.cardNum;
      if (optionsRequired.unassign) this.cardNumIsSet = false;
      else this.cardNumIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CardNumDTOTrackedI {
    const cloned = {} as CardNumDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.cardNumIsSetDeep() &&
      this.cardNumApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardNumIsSet = true;
      cloned.cardNum = this.cardNum;
    } else {
      //cloned.cardNumIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CardNumDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.cardNumApplyFilter(filter)) this.cardNumIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardNumDTOMeta.assignId, CardNumDTOMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  cardNumApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardNumDTOMeta.cardNum, CardNumDTOMeta, this.cardNum, this);
  }
  cardNumIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardNumIsSet && this.cardNumApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.cardNumIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
